import * as React from "react";
import { APIConfig, hrLogin, isUserLocked } from "../API";
import { AgencyLoginScreen } from "../components/AgencyLoginScreen";
import { Loading, loading } from "../Loading";
import { AgencyMemberAuthInfo } from "../messages/Auth";

interface AgencyLoginActivityProps {
    apiConfig: APIConfig;
    onSuccessfulLogin: (agencyMemberAuthInfo: AgencyMemberAuthInfo) => void;
}

interface AgencyLoginActivityState {
    showLoginError: string | null | Loading;
}

export class AgencyLoginActivity extends React.Component<AgencyLoginActivityProps, AgencyLoginActivityState> {
    constructor(props: AgencyLoginActivityProps) {
        super(props);

        this.state = {
            showLoginError: null
        };
    }

    handleSubmitClick = async (email: string, password: string) => {
        this.setState({ showLoginError: loading() });

        const code = localStorage.getItem("code");
        const resp = await hrLogin(this.props.apiConfig, {
            email: email,
            password: password,
            code: code === null ? undefined : code
        });

        if (resp === null) {
            this.setState({ showLoginError: "Wrong credentials" });
            return;
        } else if (isUserLocked(resp)) {
            this.setState({ showLoginError: "This user has been locked due to suspicious activity, contact support for more info" });
        } else {
            const agencyMemberAuthInfo: AgencyMemberAuthInfo = {
                agency: resp.agency,
                agencyMember: resp.agencyMember,
                agencyMemberAccessKey: resp.accessKey
            };

            localStorage.setItem("agencyMemberAuthInfo", JSON.stringify(agencyMemberAuthInfo));

            this.props.onSuccessfulLogin(agencyMemberAuthInfo);
        }
    }

    render() {
        return (
            <AgencyLoginScreen
                showLoginError={this.state.showLoginError}
                onSubmitClick={(email, password) => this.handleSubmitClick(email, password)}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/activities/AgencyLoginActivity.tsx